export const PXCopyVideo = (function() {
	'use strict';

	let $block;
	function init() {
		$block = $('.pxblock--copy-video');
		events();
	}

	function events() {
		$block.next('.pxblock--icon-blocks').addClass('padding--mins-top');
	}

	return {
		init: init
	};
})();
